import { post, get } from '../network/index.js'

// 翡翠宫接口-未使用
// //获取验证码
// const getLoginCode = (data) => {
//   return post("/webi/webUserLogin/getLoginCode", data);
// };
// //登录
// const queryLogin = (data) => {
//   return post("/webi/webUserLogin/checkCode", data);
// };

//退出登录
const loginout = data => {
  return post('/mercWebi/login/loginout', data)
}

//获取唯一二维码
const getScanCode = data => {
  return get('/mercWebi/login/getScanCode', data)
}

//检验是否登陆
const checkCode = data => {
  return post('/mercWebi/login/checkCode', data)
}

//翡翠宫-商家登陆
const pseudoLogin = data => {
  return post('/mercWebi/login/pseudoLogin', data)
}

// 查询子账号列表
const queryAccountList = data => {
  return post('/mercWebi/webAccountInfo/queryAccountListByPhone', data)
}

// 账号密码登录
const loginPwd = data => {
  return post('/mercWebi/login/loginPwd', data)
}

export default {
  // getLoginCode,
  // queryLogin,
  loginout,
  getScanCode,
  checkCode,
  pseudoLogin,
  loginPwd,
  queryAccountList
}
